var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-12" },
    [
      _c("v-card-title", [
        _vm._v(" Create Expertise " + _vm._s(_vm.description) + " "),
      ]),
      _c("v-divider"),
      _c(
        "v-form",
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("pga-text-field", {
                        attrs: {
                          label: "Description",
                          "key-error": "Description",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.description,
                          callback: function ($$v) {
                            _vm.description = $$v
                          },
                          expression: "description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("pga-combobox", {
                        attrs: {
                          "item-value": "Id",
                          "item-text": "Name",
                          items: _vm.techAreasDropDown,
                          label: "Tech Areas",
                          multiple: "",
                          "return-object": "",
                          "key-error": "TechAreaIds",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.techAreaIds,
                          callback: function ($$v) {
                            _vm.techAreaIds = $$v
                          },
                          expression: "techAreaIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("pga-combobox", {
                        attrs: {
                          "item-value": "Id",
                          "item-text": "Description",
                          items: _vm.technologiesDropDown,
                          label: "Technologies",
                          multiple: "",
                          "return-object": "",
                          "key-error": "TechnologyIds",
                          errors: _vm.Errors,
                        },
                        model: {
                          value: _vm.technologyIds,
                          callback: function ($$v) {
                            _vm.technologyIds = $$v
                          },
                          expression: "technologyIds",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }